import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Address } from "@barthauer/custom/arena";
import { CompaniesService, IProjectDependency } from "../companies.service";
import { AppService } from "../../../services/app.service";

@Component({
  selector: "company-card",
  templateUrl: "./company-card.component.html",
  styleUrls: ["./company-card.component.scss"],
  standalone: false,
})
export class CompanyCardComponent {
  @Input() companies: Address[];
  @Input() filterActive = false;
  @Input() clonedCompanies: Address[];
  @Input() comapnyNumber = 0;
  @Input() navigateUrl: string;
  @Input() companyIdDependency: IProjectDependency;
  @Input() companyNameDependency: IProjectDependency;
  @Input() configDependencies: IProjectDependency[];
  @Output() clickCompany = new EventEmitter<Address>();
  @Output() hoverCompany = new EventEmitter<string>();

  constructor(public companiesService: CompaniesService,private appService:AppService) {}

  public selectCompany(company: Address) {
    sessionStorage.setItem("profileAddressId", company["ParentId"]);
    sessionStorage.setItem("companyName", company.Name);
    this.appService.switchTreeViewToCompany(true)
    this.companiesService.selectedCompanyData(true);
    this.companiesService.prepareTitleCompany(company.Name);
    sessionStorage.removeItem("projectName");

    this.clickCompany.emit(company);
  }

  public updateContent(event): void {
    if (!this.filterActive) {
      this.companies = this.clonedCompanies.slice(0, this.comapnyNumber + 100);
      this.comapnyNumber += 100;
    }
    event.component.release();
  }

  public validationFunction(company): boolean {
    return company.HouseNumber ||
      company.Street ||
      company.ZIP ||
      company.City ||
      company.Country
      ? true
      : false;
  }
}
